"use client";
import React, {useEffect} from "react";
import {Box} from "@chakra-ui/react";

const HubspotContactForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    document.body.appendChild(script);
    script.async = true;
    script.defer = true;
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "43951417",
          formId: "c98b7951-35e0-456a-a1bc-5c2e4e73042e",
          region: "na1",
          target: "#hubspotForm",
        });
      }
    });
  }, []);

  return (
    <Box
      boxShadow={"lg"}
      borderRadius={"8px"}
      px={{base: 4, sm: 8}}
      py={{base: 4, sm: 8, md: 12}}
      w={"full"}
      minH={"540px"}
    >
      <Box id="hubspotForm"></Box>
    </Box>
  );
};

export default HubspotContactForm;
